var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.96094H5.5H21.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6.96094V20.9609C19.5 21.4914 19.2893 22.0001 18.9142 22.3752C18.5391 22.7502 18.0304 22.9609 17.5 22.9609H7.5C6.96957 22.9609 6.46086 22.7502 6.08579 22.3752C5.71071 22.0001 5.5 21.4914 5.5 20.9609V6.96094M8.5 6.96094V4.96094C8.5 4.4305 8.71071 3.9218 9.08579 3.54672C9.46086 3.17165 9.96957 2.96094 10.5 2.96094H14.5C15.0304 2.96094 15.5391 3.17165 15.9142 3.54672C16.2893 3.9218 16.5 4.4305 16.5 4.96094V6.96094",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.9609V17.9609",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.9609V17.9609",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1ce3586bf9bdcdcf7f0ff3348d8188b6.svg";
export { ForwardRef as ReactComponent };